export const featureTrio = `title: Three Routes to Carbon Removal

---
subtitle: Reforestation
subtitle: Direct Air Capture
subtitle: Ocean Alkalinity
---
Absorbs 3-5 tonnes CO2/ha/year at $5-50/tonne. Limited by land availability and impermanence — wildfire and disease can release stored carbon within decades. (Bastin et al., Science, 2019)
Industrial fans draw air through chemical sorbents binding CO2. Costs $250-600/tonne but requires minimal land and stores carbon geologically for millennia. Reaching gigatonne scale by 2050 requires thousandfold expansion. (IEA, 2022)
Adding calcium or magnesium minerals to seawater accelerates weathering that converts dissolved CO2 into stable bicarbonates. Costs $50-150/tonne with storage over 10,000 years. Ecological effects at scale remain uncertain. (National Academies, 2022)
-->
`;
